// extracted by mini-css-extract-plugin
export default {"readerModalContent":"Reader_readerModalContent__7wzZH","active":"Reader_active__N+f6H"};